// 功能模块管理 
import http from '../httpConfig'

// 产品详情
const table = 'mrbase_sys_products'
export const get_detail = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/products/find-products-particulars/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
// 产品修改
export const get_update = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/products/update-products-particulars/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}